
import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { useRef, useEffect } from 'react'
import {DisplayTestEditMode} from './DisplayTestEditMode'
import { DialogModifyTest } from './DialogModifyTest';
import { WaitonResponse } from '../waitonresponse/WaitonResponse';

import "./aitest.css"

export const QuestionsOne = ({  promptsandresponses, correctanswersonly }) => {

  let {
    isMobile,
  } = React.useContext(StatusContext);

  let {
    onDeletePrompt,
    onCancelDelete,
    onAcceptDelete,
    onChange,
    onSubmitAnswer,
    onAcceptAnswer,
    onResetAnswer,
    onMoveUpSubtopics,
    onMoveDownSubtopics,
    testpreview,
    onMoreAnswer,
    onMoreQuestion,
    onEditTest,
    createtestmode,
    previewMessage,
    status,

  } = React.useContext(AITestContext);

  const promptAreaRef = useRef(null);

  useEffect(() => {
    console.log("Question: useEffect")

    if (promptAreaRef.current) {
      promptAreaRef.current.style.height = 'auto';
      promptAreaRef.current.style.height = `${promptAreaRef.current.scrollHeight}px`;
    }
  }, [promptAreaRef]);

 
  return (

    <div style={{ width: "100%", paddingLeft:isMobile() ? '0%' : '0%',   paddingRight: isMobile() ? '0%' : '0%'}}>
      {
        <>
        
          {
            (testpreview) &&
            <>
              <label style={{ color: 'red', fontSize: '20px', }}>{previewMessage}</label>
              <br></br>
              <br></br>
            </>
          }
          <div className="questionsarea">
              {
                Array.isArray(promptsandresponses) &&
                promptsandresponses.map((item, idx) => (
                 
                    <DisplayTestEditMode key={item.id} displayprompt={item} disableMoveUp={idx === 0}
                      disableMoveDown={idx === (promptsandresponses.length - 1)}
                      onCancelDelete={onCancelDelete}
                      onAcceptDelete={onAcceptDelete}
                      onDeletePrompt={onDeletePrompt}
                      onSubmitAnswer={onSubmitAnswer}
                      onAcceptAnswer={onAcceptAnswer}
                      onResetAnswer={onResetAnswer}
                      onChange={onChange}
                      onMoveUp={onMoveUpSubtopics}
                      onMoveDown={onMoveDownSubtopics}
                      seqid={idx + 1}
                      total={promptsandresponses.length}
                      onMoreAnswer={onMoreAnswer}
                      onMoreQuestion={onMoreQuestion}
                      onEditTest={onEditTest}
                    
                    />
                    
                ))
              }
         
          </div>

          <div className="mainButtons">
            {
              createtestmode ?
                null
                :
                <div style={{ width: '60%' }}>
                  <label> </label>
                </div>

            }

              {
                  (!status) &&
                      <WaitonResponse />
              }

         
          </div>
        </>

      }
      {/*<DialogMoreAnswer />*/}
      <DialogModifyTest />

    </div>

  )

}

QuestionsOne.defaultProps = {
  correctanswersonly: false,
};




